<template>
  <div>
    <i class="fa fa-clock-o fa-fw mr-2"></i>{{ startTime }} - {{ endTime
    }}<i class="fa fa-calendar-o fa-fw ml-4 mr-2"></i>{{ date }}
  </div>
</template>

<script>
export default {
  name: 'EventDateTimeComponent',
  props: {
    date: {
      type: String,
      default: '',
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
